module.exports = __webpack_public_path__ + "static/media/banner_Heist-half.70b6d4a5.png";